import React from 'react';
import { ConfigProvider, Menu as AntMenu, Dropdown as AntDropdown, DropDownProps } from 'antd';
import { MenuProps, MenuItemProps, MenuDividerProps } from 'antd/lib/menu';
import { DropdownButtonProps } from 'antd/lib/dropdown';
import styled from 'styled-components';

import { nextDropdownTheme, nextMenuTheme } from '../next/tokens';

export type { MenuProps } from 'antd/lib/menu';
export type { MenuItemProps } from 'antd/lib/menu';
export type { DropDownProps } from 'antd/lib/dropdown';

type DropdownVariant = 'next';

interface DropdownWithVariantProps extends DropDownProps {
  variant?: DropdownVariant;
}

export const Dropdown: React.FC<DropdownWithVariantProps> = ({ variant, ...props }) => {
  if (variant === 'next') {
    const overlayClassName = ['ant-dropdown-next', props.overlayClassName]
      .filter(Boolean)
      .join(' ');

    return (
      <ConfigProvider theme={nextDropdownTheme}>
        <AntDropdown {...props} overlayClassName={overlayClassName} />
      </ConfigProvider>
    );
  }
  return <AntDropdown {...props} />;
};

type MenuVariant = 'next';

interface MenuWithVariantProps extends MenuProps {
  variant?: MenuVariant;
}

/**
 * Minimal CSS for Menu next variant — only for things ConfigProvider tokens can't express.
 */
const NextMenu = styled(AntMenu)`
  &.ant-menu {
    border: none !important;

    .ant-menu-item {
      padding-inline-start: 4px;
      padding-inline-end: 6px;
      margin-inline: 0;
      width: 100%;
      color: ${({ theme }) => theme.token.next.palette.grey800};
    }

    .ant-menu-item-divider {
      border-color: ${({ theme }) => theme.token.next.palette.grey75};
    }
  }
` as typeof AntMenu;

export const Menu: React.FC<MenuWithVariantProps> = ({ variant, ...rest }) => {
  if (variant === 'next') {
    return (
      <ConfigProvider theme={nextMenuTheme}>
        <NextMenu {...rest} />
      </ConfigProvider>
    );
  }
  return <AntMenu {...rest} />;
};

export const MenuItem: React.FC<MenuItemProps> = (props) => <AntMenu.Item {...props} />;

export const DropdownButton: React.FC<Omit<DropdownButtonProps, 'arrow'>> = ({
  size = 'large',
  ...rest
}) => <AntDropdown.Button size={size} {...rest} />;

export const MenuDivider: React.FC<MenuDividerProps> = (props) => <AntMenu.Divider {...props} />;
